import analyticCounters from '@media-platform/analytic-counters/src';

const AnalyticCounters = analyticCounters({
  counters: { common: {} },
  debug: process.env.NODE_ENV === 'development',
});

export const counterTriggerAll = () => {
  AnalyticCounters.triggerAll();
};
